import { useDisclosure } from '../../hooks/useDisclosure';
import styled from 'styled-components';
import { Text } from '../Text/Text';
import { Flex } from '../Flex/Flex';
import { View } from '../View/View';
import { headerPaddingStyles, chevronSize, panelStyles, headerElement } from './Accordion.helpers';
import { RightIcon, DownIcon } from 'foundations-assets';
import { useTrellisFocusRing } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAccordionHeader = styled.button.withConfig({
  displayName: "Accordion__StyledAccordionHeader",
  componentId: "sc-3khiwq-0"
})(({
  $focusRingStyles,
  $titleSize = 'medium',
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({}, $focusRingStyles, {
    alignItems: 'center',
    border: 'none',
    backgroundColor: theme.color['fill-surface-default'],
    borderRadius: theme.borderRadius['100'],
    color: theme.color['text-primary-default'],
    cursor: 'pointer',
    display: 'inline-flex',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    justifyContent: 'start',
    position: 'relative',
    paddingInlineStart: theme.space[headerPaddingStyles[$titleSize]],
    inlineSize: '100%',
    '&[aria-disabled="true"]': {
      cursor: 'not-allowed'
    },
    '&:hover:not([aria-disabled="true"])': {
      color: theme.color['text-interactive-default-hover']
    }
  });
});
export const Accordion = ({
  children,
  disabled = false,
  defaultExpanded = false,
  expanded,
  onExpandedChange,
  renderContent,
  title,
  titleSize = 'medium'
}) => {
  const {
    focusProps,
    focusRingStyles
  } = useTrellisFocusRing({});
  const {
    isOpen,
    triggerElementAriaAttributes,
    onToggle
  } = useDisclosure({
    defaultIsOpen: defaultExpanded,
    isOpen: expanded,
    onOpen: () => onExpandedChange === null || onExpandedChange === void 0 ? void 0 : onExpandedChange(true),
    onClose: () => onExpandedChange === null || onExpandedChange === void 0 ? void 0 : onExpandedChange(false)
  });
  const panelContent = typeof renderContent === 'function' ? renderContent() : children;
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: "fill-surface-default",
    children: [/*#__PURE__*/_jsx(Text, {
      as: headerElement[titleSize],
      children: /*#__PURE__*/_jsxs(StyledAccordionHeader, Object.assign({}, focusProps, triggerElementAriaAttributes, {
        $titleSize: titleSize,
        $focusRingStyles: focusRingStyles,
        "aria-disabled": disabled,
        onClick: !disabled ? onToggle : undefined,
        children: [/*#__PURE__*/_jsx(Flex, {
          position: "absolute",
          insetBlockStart: "0",
          insetBlockEnd: "0",
          insetInlineStart: "0",
          justifyContent: "center",
          alignItems: "center",
          children: isOpen ? /*#__PURE__*/_jsx(DownIcon, {
            color: "icon-interactive-hover",
            size: chevronSize[titleSize]
          }) : /*#__PURE__*/_jsx(RightIcon, {
            color: "icon-interactive-hover",
            size: chevronSize[titleSize]
          })
        }), title]
      }))
    }), isOpen ? /*#__PURE__*/_jsx(Flex, Object.assign({}, panelStyles[titleSize], {
      flexDirection: "column",
      children: panelContent
    })) : null]
  });
};